<template>
  <div class="openingSteps tw-w-full tw-bg-white tw-py-24">
    <div
      class="tab-view-container medium-item tw-w-full tw-flex tw-flex-col"
      :class="{ 'animate-slide-up': isVisible }"
    >
      <p
        class="tw-text-4xl tw-text-textMain tw-font-semibold tw-text-center tw-mb-16"
      >
        <span class="tw-text-primary">{{ $t("3步") }}</span>
        <span>{{ $t("开启您的区块链转型") }}</span>
      </p>

      <!-- 步骤容器 -->
      <div class="steps-container tw-relative">
        <div id="steps-wrapper" class="steps-wrapper" ref="stepsWrapper">
          <!-- 循环渲染步骤 -->
          <div
            v-for="(item, index) in stepsList"
            :key="index"
            class="step-item"
            :class="{ active: currentStep === index }"
          >
            <div
              class="step-inner tw-flex tw-flex-col md:tw-flex-row tw-gap-20"
            >
              <!-- 图片区域 -->
              <div class="step-image-container">
                <img
                  :src="item.img"
                  alt=""
                  class="step-image tw-w-full tw-h-full tw-object-cover"
                />
              </div>

              <!-- 文字+数字区域 -->
              <div class="tw-flex tw-items-center tw-gap-20">
                <div class="tw-w-80">
                  <div class="step-title">{{ item.title }}</div>
                  <div class="step-description">{{ item.description }}</div>
                </div>

                <div class="step-number-container">
                  <div class="step-number">{{ index + 1 }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
export default {
  name: "openingSteps",
  props: {},
  components: {},
  data() {
    return {
      isVisible: false,
      currentStep: 0,
      stepsList: [
        {
          img: "https://ts-apk.s3.ap-east-1.amazonaws.com/skysp-guanwang%2Fd4aae37a-cc57-475c-b324-43c4223d6512.png",
          title: "咨询对话",
          description: "专属顾问1对1沟通，定制区块链解决方案",
        },
        {
          img: "https://ts-apk.s3.ap-east-1.amazonaws.com/skysp-guanwang%2Fd7bd6d6f-f9e7-4ae3-bcc5-fef5be8fbf7c.png",
          title: "报价签约",
          description: "透明报价，分阶段付款，签订合同",
        },
        {
          img: "https://ts-apk.s3.ap-east-1.amazonaws.com/skysp-guanwang%2Fd3681011-4925-4783-ba4f-d726c21755fb.png",
          title: "项目实施",
          description: "为您量身定制，提供从界面设计到完整功能上线的全流程交付",
        },
      ],
      observer: null,
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.initStepSwitching();
        this.initIntersectionObserver();
      }, 500);
    });
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
    // 清理ScrollTrigger
    ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
  },
  methods: {
    initIntersectionObserver() {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.isVisible) {
              this.isVisible = true;

              // 动画只执行一次，所以可以断开观察器
              this.observer.disconnect();
            }
          });
        },
        {
          threshold: 0.1, // 当组件10%可见时触发
        }
      );

      this.observer.observe(this.$el);
    },
    initStepSwitching() {
      setTimeout(() => {
        // 清除现有的ScrollTrigger实例
        ScrollTrigger.getAll().forEach((trigger) => trigger.kill());

        // 创建主滚动控制器
        ScrollTrigger.create({
          trigger: ".openingSteps",
          start: "bottom bottom",
          end: () => `+=${window.innerHeight * 2}`, // 控制滚动距离
          pin: true,
          pinSpacing: true,
          scrub: 1,
          onUpdate: (self) => {
            // 更平滑的步骤切换计算
            const progress = Math.min(Math.max(self.progress, 0), 1);
            const stepIndex = Math.floor(progress * this.stepsList.length);

            // 确保索引在有效范围内
            const safeIndex = Math.min(
              Math.max(stepIndex, 0),
              this.stepsList.length - 1
            );

            if (this.currentStep !== safeIndex) {
              this.currentStep = safeIndex;
            }
          },
        });

        ScrollTrigger.refresh();
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.openingSteps {
  background: #f9fafc;
}
.tab-view-container {
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s ease-out;
}

.tab-view-container.animate-slide-up {
  opacity: 1;
  transform: translateY(0);
}

.steps-container {
  position: relative;
  padding: 20px 0;
}

.steps-wrapper {
  display: flex;
  width: 100%;
  overflow: hidden;
}

.step-item {
  width: 100%;
  flex-shrink: 0;
  padding: 0 20px;
  box-sizing: border-box;
  scroll-snap-align: start;
  display: flex;
  justify-content: center;
  opacity: 0;
  position: absolute;
  transition: opacity 0.5s ease-in-out;
}
.step-item.active {
  opacity: 1;
  position: relative;
  transition: opacity 0.5s ease-in-out;
}

.step-inner {
  width: 100%;
  max-width: 1300px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin: 0 auto;
}

.step-image-container {
  width: 700px;
  height: 500px !important;
  position: relative;
  border-radius: 8px;
  overflow: hidden;

  .step-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .image-decoration {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 2px dashed rgba(64, 119, 248, 0.3);
    border-radius: 8px;
  }
}

/* 步骤数字：浅蓝色描边空心样式 */
.step-number-container {
  margin-bottom: 12px;
}
.step-number {
  font-size: 300px;
  font-weight: bold;
  color: transparent;
  -webkit-text-stroke: 2px #4077f8;
}

.step-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}

.step-description {
  font-size: 16px;
  color: #666;
  line-height: 1.6;
}

/* 标题入场动画 */
.animate-slide-up {
  animation: slideUp 0.6s ease-out forwards;
}
@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 桌面端布局调整 */
@media (min-width: 768px) {
  .step-inner {
    flex-direction: row;
    gap: 30px;
  }

  .step-image-container {
    height: 300px;
  }

  .step-content-container {
    padding: 0;
  }
}
</style>
